import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-[600px] lg:min-h-[700px] bg-gray-50 mt-[73px]">
      <div className="grid lg:grid-cols-2 gap-0 h-full">
        {/* Left - Image */}
        <div className="relative h-[400px] lg:h-[700px] overflow-hidden">
          <img
            src="/aboutphoto.png"
            alt="lALIEL STORE"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Right - Content */}
        <div className="relative flex flex-col items-center justify-center px-6 lg:px-12 py-16 lg:py-24 bg-white">
          <div className="max-w-xl text-center">
            {/* Logo */}
            <div className="mb-8">
              <img 
                src="/laliel-logo.png" 
                alt="Laliel" 
                className="h-28 lg:h-36 w-auto mx-auto object-contain filter drop-shadow-sm"
              />
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-serif tracking-[0.2em] mb-4">
              L'Aliel
            </h1>
            <p className="text-sm tracking-[0.3em] text-gray-600 mb-8 border-t border-b border-gray-300 py-3">
              STORE
            </p>

            <h2 className="text-2xl lg:text-3xl font-serif mb-6 leading-relaxed">
              İNCƏ ZÖVQ. KÜBAR DURUŞ.
              <br />ZAMANA MEYDAN OXUYAN DETALLAR.
            </h2>

            <p className="text-gray-600 leading-relaxed mb-8">
             Minimalizmin asilliyini yüksək keyfiyyətlə birləşdiririk. <br />
              Çünki əsl dəbdəbə diqqətlə seçilmiş detallarda gizlidir.
            </p>

            {/* New Collection Badge */}
{/*             <div className="inline-flex items-center justify-center w-32 h-32 border-2 border-black rounded-full mb-8"> */}
{/*               <div className="text-center px-4"> */}
{/*                 <div className="text-xs font-bold tracking-wider leading-tight"> */}
{/*                   YENİ<br />KOLLEKSİYA<br />İNDİ */}
{/*                 </div> */}
{/*                 <div className="text-[9px] tracking-wider mt-2">MAĞAZAMIZDA!</div> */}
{/*               </div> */}
{/*             </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;